import FetchService from "../FetchService/CustomService";
import { getErrorMessage } from "../utils";

const BaseUrl = process.env.BASE_URL;

const JobPostFieldsService = {
  /**
   * Fetch job post fields from the API
   * @param {number} [categoryId] - Optional category ID to filter fields
   * @returns {Promise} API response with job post fields data
   */
  async getJobPostFields(categoryId) {
    const url = BaseUrl + "/v2/metadata/v2/job_post_fields";
    const loaderConfig = { hasLoader: false };

    // Build query parameters object only if categoryId is provided
    const queryParams = {};
    if (categoryId !== undefined && categoryId !== null) {
      queryParams.category_id = categoryId;
    }

    try {
      const res = await FetchService.getCall({
        url,
        query: queryParams,
        loaderConfig
      });

      return res;
    } catch (error) {
      console.log("JobPostFieldsService error:", error);
      return Promise.reject(getErrorMessage(error));
    }
  }
};

export default JobPostFieldsService;
